import { Injectable } from "@angular/core";
import { SwUpdate } from "@angular/service-worker";
import { filter } from "rxjs/operators";
import { UpdateDialogComponent } from "@assoanalytics/app/shared/components/update-dialog/update-dialog.component";
import { AlertDialogService } from "@assoanalytics/app/shared/services/alert-dialog/alert-dialog.service";
import { MatDialogRef } from "@angular/material/dialog";

@Injectable({ providedIn: "root" })
export class UpdateService {
  constructor(
    private updates: SwUpdate,
    private alertDialog: AlertDialogService
  ) {}

  public init(): void {
    this.listenForUpdates();
  }

  private listenForUpdates() {
    if (!this.updates.isEnabled) return;
    this.updates.versionUpdates
      .pipe(filter((evt) => evt.type === "VERSION_READY"))
      .subscribe(() => this.promptUser());
  }

  private promptUser() {
    // Usa AlertDialogService per mostrare il dialog custom e gestire la risposta
    const dialogRef = this.alertDialog.openModal(
      UpdateDialogComponent,
      {},
      true
    );
    if (dialogRef && dialogRef.afterClosed) {
      dialogRef.afterClosed().subscribe((result) => {
        if (result === "update") {
          this.doUpdate();
        }
        // else: do nothing ("Più tardi")
      });
    }
  }

  private doUpdate() {
    // Pulizia cookie (solo se necessario e consentito)
    document.cookie.split(";").forEach((c) => {
      document.cookie = c
        .replace(/^ +/, "")
        .replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/");
    });
    this.updates.activateUpdate().then(() => document.location.reload());
  }
}
